import m from "../../../../geodata/es2015/region/usa/dcHigh";
window.am4geodata_region_usa_dcHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/dcHigh.js
// module id = null
// module chunks = 